import * as stylex from '@stylexjs/stylex';
import { MdCalendarToday, MdPlace, MdOpenInNew } from 'react-icons/md';
import { formatDateTime } from '~utils';
import { styles } from './styles';
import type { PublicSpotDetail } from '~pages/Spot/query';
export function Details({
  spot
}: {
  spot: PublicSpotDetail;
}) {
  const when = spot.type === 'EVENT' ? spot.event?.scheduledAt ?? null : null;
  const locationName = spot.type === 'EVENT' ? spot.event?.locationName ?? null : null;

  // Flutter's WHERE: locationName preferred, else address; if both, address is
  // the subtitle. (Distance is dropped — it needs the viewer's location.)
  const whereValue = locationName ?? spot.address ?? 'Location';
  const whereSubtitle = locationName && spot.address ? spot.address : null;
  const {
    latitude,
    longitude
  } = spot.coordinates;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  return <section {...stylex.props(styles.card)}>
      {when && <>
          <div {...stylex.props(styles.row)}>
            <MdCalendarToday size={20} {...stylex.props(styles.iconWhen)} />
            <div {...stylex.props(styles.col)}>
              <span {...stylex.props(styles.label)}>When</span>
              <span {...stylex.props(styles.value)}>{formatDateTime(when)}</span>
            </div>
          </div>
          <div {...stylex.props(styles.divider)} />
        </>}

      <a {...stylex.props(styles.row, styles.whereLink)} href={mapsUrl} target="_blank" rel="noreferrer">
        <MdPlace size={20} {...stylex.props(styles.iconWhere)} />
        <div {...stylex.props(styles.col)}>
          <span {...stylex.props(styles.label)}>Where</span>
          <span {...stylex.props(styles.value)}>{whereValue}</span>
          {whereSubtitle && <span {...stylex.props(styles.subtitle)}>{whereSubtitle}</span>}
        </div>
        <MdOpenInNew size={18} {...stylex.props(styles.openIcon)} />
      </a>
    </section>;
}